import PipelinesAsCodePrompt from './PipelinesAsCodePrompt';

export default PipelinesAsCodePrompt;
